import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Form, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import Loader from '../../components/Loader';
import { store } from '../../redux/store';
import smartHttp from '../../helpers/smartHttp';
import CommonDropdown from '../../sharedcomponents/CommonDropdown/CommonDropdown';
import TextFieldInput from '../../sharedcomponents/TextFieldInput/TextFieldInput';
import { trimFormValues } from '../../helpers';
import {
  Endpoints,
  loaderStyle,
  ReduxAction,
  UserId,
  ContractDisplayOptions,
  GenericError,
} from '../../constants';
import { Notify } from '../../sharedcomponents/Alert/Notify';
import './locations.scss';

const LocationMappingPopup = ({
  show,
  handleClose,
  contracts,
  afterSave,
  loading,
  sourceType,
  contractDisplayOption,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isValueChanged, setIsValueChanged] = useState(false);
  const [initialLocatonValue, setInitialLocatonValue] = useState();
  const [accountsData, setAccountsData] = useState([]);
  const [contractLocations, setContractLocations] = useState([]);
  const [countryStateInfo, setCountryStateInfo] = useState({});
  const [localLoading, setLocalLoading] = useState(false);
  let locationInitialValue = {
    contractNumber: '',
    oldLocation: '',
    newLocation: '',
  };
  const dispatch = useDispatch();
  contracts = contracts ?? [];

  const SubmitHandler = async (value) => {
    const mappingData = {
      p_location_details: [{
        old_officelocationid: value.oldLocation,
        new_officelocationid: value.newLocation,
        contractnumber: value.contractNumber,
      }],
      p_user: UserId,
      p_exhibit_flow: 0,
    };
    try {
      setLocalLoading(true);
      const resp = await smartHttp.putRapid(Endpoints.updateLocationMappingApi, mappingData);
      if (resp?.data?.success === true || resp?.data?.data[0]?.p_error === 0) {
        Notify({
          alert: true,
          type: 'success',
          title: 'Location mapping updated successfully',
          confirmBtnText: 'OK',
        });
        dispatch({ type: ReduxAction.locationTransferSaved, payload: Date.now() });
        afterSave?.();
        handleClose();
      }
    } catch (error) {
      Notify({
        alert: true,
        type: 'error',
        title: GenericError.somethingWentWrong,
      });
    } finally {
      setLocalLoading(false);
    }
  };

  const locationTransferValidate = Yup.object({
    contractNumber: Yup.string().required(
      'Please select a contract number to proceed',
    ),
    oldLocation: Yup.string().required(
      'Please select an old location to proceed',
    ),
    newLocation: Yup.string().required(
      'Please select a new location to proceed',
    ),
  });


  const locationTransferFormik = useFormik({
    initialValues:  locationInitialValue,
    validationSchema: locationTransferValidate,
    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  // useEffect(() => {
  //   try {
  //     if (isEdit) {
  //       if (
  //         JSON.stringify(initialLocatonValue) !==
  //         JSON.stringify(locationFormik.values)
  //       ) {
  //         setIsValueChanged(true);
  //       } else {
  //         setIsValueChanged(false);
  //       }
  //     }

  //     if (locationFormik.values.country) {
  //       setStateValues(locationFormik.values.country);
  //     }
  //   } catch (error) {}
  // }, [locationFormik.values]);

  const getContractLabelKey = () => {
    if (contractDisplayOption) {
      if (
        contractDisplayOption.preferenceValue ===
        ContractDisplayOptions[1].contractDisplayOption
      ) {
        return 'contractDescription';
      }
      if (
        contractDisplayOption.preferenceValue ===
        ContractDisplayOptions[2].contractDisplayOption
      ) {
        return 'label';
      }
    }

    return 'contractNumber';
  };

  const onChangeHandler = async (val, name) => {
    // let value;

    // if (name === 'contractNumber' && val && typeof val === 'object') {
    //   value = val.value;
    // } else {
    //   value = val[name] ?? val;
    // }

    let obj = {
      target: { name: name, value: val.value },
    };
    locationTransferFormik.handleChange(obj);
    if (name === 'contractNumber') {
      await getContractLocation(val.value);
    }

    if(name === 'oldLocation'){
      locationTransferFormik.setFieldValue('newLocation', '');
    }
  };

  // const setStateValues = (countryName) => {
  //   let foundCountry = countryStateInfo?.CS_main?.find(
  //     (el) => el.country === countryName,
  //   );
  //   let stateList = foundCountry?.states?.map((el) => el?.state ?? el) ?? [];
  //   stateList = stateList.sort((a, b) =>
  //     a.localeCompare(b, undefined, { sensitivity: 'base' }),
  //   );

  //   setCountryStateInfo({
  //     ...countryStateInfo,
  //     filteredState: stateList,
  //   });
  // };
  const getContractLocation = async (contractNumber) => {
    setLocalLoading(true);
    const queryParams = {
      Filter: `contractNumber:"${contractNumber}"`,
      Field: 'officeLocationId,accountId,hC_AccountID,officeLocationName,accountName',
      PageSize: 5000,
    };
    await smartHttp
      .get(Endpoints.locationApi, queryParams)
      .then((res) => {
        const response = res?.data?.results;
        if (response?.length > 0) {
          setContractLocations(response);
        } else {
          setContractLocations([]);
        }
      })
      .catch((error) => {
        console.error(error);
        setContractLocations([]);
        Notify({
        alert: true,
        type: 'error',
        title: GenericError.somethingWentWrong,
      });
      })
      .finally(() => {
        setLocalLoading(false);
      });
  };

  const getContractDropdownOptions = (
    contracts,
    selectedContractNumber,
    getContractLabelKey,
  ) => {
    return contracts
      .filter((contract) => {
        // Always show non-VCN contracts
        if (contract.isVirtualContract !== 1) return true;
        // Show VCN only if the selected contract is mapped to this VCN
        return (
          contract.mappedContractNumber &&
          contract.mappedContractNumber
            .split(',')
            .map((num) => num.trim())
            .includes(selectedContractNumber)
        );
      })
      .map((contract) => ({
        label: contract[getContractLabelKey()] ?? '',
        value: contract.contractNumber,
        // Always disable VCN option so it can't be selected
        disabled: contract.isVirtualContract === 1,
      }));
  };


  const getoldLocationDropdownOptions = () => {
    return contractLocations.map((el) => ({
      label: el.officeLocationName,
      value: el.officeLocationId,
    }));
  };

  const getNewLocationDropdownOptions = () => {
    if (!locationTransferFormik.values.oldLocation) return [];
    return contractLocations
      .filter((el) => el.officeLocationId !== locationTransferFormik.values.oldLocation)
      .map((el) => ({
        label: el.officeLocationName,
        value: el.officeLocationId,
      }));
  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        backdrop="static"
      >
        {(loading || localLoading) && <Loader type="scaleLoader" cssClass={loaderStyle} />}

        <Modal.Header closeButton>
          <span className="location-form-title">
            Location Transfer Mapping
          </span>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={locationTransferFormik.handleSubmit} className="row mb-0">
            <Row className="pe-0">
            <CommonDropdown
              mode="single"
              enableSearch={true}
              formLabel="Contract"
              name="contractNumber"
              options={getContractDropdownOptions(
                contracts,
                locationTransferFormik.values.contractNumber,
                getContractLabelKey,
              )}
              formik={locationTransferFormik}
              ddPlaceHolder={
                locationTransferFormik.values.contractNumber !== '' &&
                contracts?.length > 0
                  ? contracts.find(
                      (el) =>
                        el.contractNumber ===
                        locationTransferFormik.values.contractNumber,
                    )?.[getContractLabelKey()] || 'Select'
                  : 'Select'
              }
              labelKeyName="label"
              ddName="contracts"
              onChangeHandler={(e) => onChangeHandler(e, 'contractNumber')}
              addAsterisk
            />
            </Row>
            <Row className="pe-0">
            <CommonDropdown
              mode="single"
              enableSearch={true}
              searchKeys={['officeLocationName']}
              formLabel="Old Location"
              name="oldLocation"
              options={getoldLocationDropdownOptions()}
              formik={locationTransferFormik}
              ddPlaceHolder={
                locationTransferFormik.values.oldLocation !== '' &&
                contractLocations?.length > 0
                  ? contractLocations.filter(
                      (el) => el.officeLocationId === locationTransferFormik.values.oldLocation,
                    )[0]?.officeLocationName
                  : 'Select'
              }
              labelKeyName="label"
              ddName="oldLocation"
              onChangeHandler={(e) => onChangeHandler(e, 'oldLocation')}
              addAsterisk
            />
            
            <CommonDropdown
              mode="single"
              enableSearch={true}
              searchKeys={['officeLocationName']}
              formLabel="New Location"
              name="newLocation"
              options={getNewLocationDropdownOptions()}
              formik={locationTransferFormik}
              ddPlaceHolder={
                locationTransferFormik.values.newLocation !== '' &&
                contractLocations?.length > 0
                  ? contractLocations.filter(
                      (el) => el.officeLocationId === locationTransferFormik.values.newLocation,
                    )[0]?.officeLocationName
                  : 'Select'
              }
              labelKeyName="label"
              ddName="newLocation"
              onChangeHandler={(e) => onChangeHandler(e, 'newLocation')}
              addAsterisk
            />

            </Row>
            <Row className="pe-0">
              <TextFieldInput
                formLabel="Old Account Name"
                placeholder="Account Name"
                id="oldAccountName"
                value={contractLocations.find(el => el.officeLocationId === locationTransferFormik.values.oldLocation)?.accountName || ''}
                readOnly
              />
              <TextFieldInput
                formLabel="New Account Name"
                placeholder="Account Name"
                id="newAccountName"
                value={contractLocations.find(el => el.officeLocationId === locationTransferFormik.values.newLocation)?.accountName || ''}
                readOnly
              />
            </Row>
            <Row className="pe-0">
              <Form.Group className="pe-0 mb-1 user-save-btn-body">
                <button
                  type="Submit"
                  className="btn btn-dark float-end btn-opacity me-2"
                  disabled={isEdit && !isValueChanged}
                >
                  Save
                </button>
              </Form.Group>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LocationMappingPopup;
